export default __webpack_public_path__ + "f0dc54ad11c02be822b49cea5880a2ac.svg";